export default "__VITE_ASSET__DSkDVndt__"